import { Box, Typography } from "@mui/material";
import { memo } from "react";
import DynamicIcon from "@entrilia/shared/components/DynamicIcon";
import IconTile from "./IconTile";
import type { IconOption } from "./iconOptions";

interface Props {
  options: IconOption[];
  selectedIconName?: string;
  onChange: (iconName: string) => void;
}

const IconGrid = ({ options, selectedIconName, onChange }: Props) => {
  if (options.length === 0) {
    return <Typography color="textSecondary">No icons match this search.</Typography>;
  }

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(30px, 1fr))",
        justifyItems: "center",
        gap: 0.5,
      }}
    >
      {options.map(({ iconName, label }) => (
        <IconTile
          key={iconName}
          label={label}
          selected={iconName === selectedIconName}
          onClick={() => onChange(iconName)}
        >
          <DynamicIcon iconName={iconName} color="inherit" />
        </IconTile>
      ))}
    </Box>
  );
};

export default memo(IconGrid);
